<template>
    <CompanyBoxContent :title="$t('company.criminalRecord') + ':'">
        <template #data>
            <div class="col-12">
                <div class="box">
                    <p>
                        {{ company.criminal_record.text }}
                    </p>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>
<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"

export default {
    props: {
        company: {
            type: Object,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
    },
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";
</style>